import { appPaths } from "../../Routes";
import { defaultScopeValue } from "../../api/activity-data";
import RatioMetricCard from "../RatioMetricCard";
import SectionTitle from "../SectionTitle";

export type EmissionFactorsSectionProps = {
    activityDataPointsTotalCount: number;
    dataSourcesTotalCount: number;
    activityDataPointsWithNoEmissionsFactorCount: number;
    dataSourcesWithNoEmissionsFactorCount: number;
};

const EmissionFactorsSection = ({
    activityDataPointsTotalCount,
    dataSourcesTotalCount,
    activityDataPointsWithNoEmissionsFactorCount,
    dataSourcesWithNoEmissionsFactorCount,
}: EmissionFactorsSectionProps) => {
    return (
        <div className="space-y-6">
            <SectionTitle title="Emission factors" />
            <div className="md:grid grid-cols-2 gap-6 space-y-6 md:space-y-0">
                <RatioMetricCard
                    title="Activity data"
                    portion={
                        activityDataPointsTotalCount -
                        activityDataPointsWithNoEmissionsFactorCount
                    }
                    total={activityDataPointsTotalCount}
                    href={`${appPaths.activityData}?dateRange=all&scope=${defaultScopeValue}`}
                />
                <RatioMetricCard
                    title="Data sources"
                    portion={
                        dataSourcesTotalCount -
                        dataSourcesWithNoEmissionsFactorCount
                    }
                    total={dataSourcesTotalCount}
                    href={appPaths.dataSources}
                />
            </div>
        </div>
    );
};

export default EmissionFactorsSection;
